import { paths } from 'routes';

const publicProfile = (type, slug) => (slug ? paths.public.companyPublicProfile(type, slug) : '');

export const getApplicationLinks = (application, { account, user }) => {
  const {
    application_id,
    ad_id,
    company_id,
    company_slug,
    buyer_name,
    buyer_slug,
    owner_supplier_name,
    owner_supplier_slug,
    contact_user_id,
    contact_user_visible,
  } = application ?? {};

  const isApplicant = !account.super_admin && user?.Company?.company_id === company_id;

  const jobAd = account.super_admin
    ? paths.adminJobAdsDetailsView(ad_id)
    : isApplicant
    ? paths.jobAdsDetailsView(ad_id)
    : `${paths.myJobAdsDetailsView(ad_id)}?tab=applications`;

  return {
    isApplicant,
    details: paths.applicationDetailsView(application_id),
    jobAd,
    supplier: publicProfile('supplier', company_slug),
    buyer: publicProfile('buyer', buyer_slug),
    postedBy: owner_supplier_name
      ? { name: owner_supplier_name, url: publicProfile('supplier', owner_supplier_slug) }
      : { name: buyer_name, url: publicProfile('buyer', buyer_slug) },
    contact: contact_user_visible ? `/app/contacts/${contact_user_id}` : '',
  };
};
